import { Component, OnInit, OnDestroy, Input } from '@angular/core'
import { StoreService } from 'app/service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { CpmService } from 'app/service/cpm.service'
import { FormControl } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
@Component({
  selector: 'app-free-float',
  templateUrl: './free-float.component.html',
  styleUrls: ['./free-float.component.scss']
})
export class FreeFloatComponent implements OnInit, OnDestroy {
  @Input() printPage
  asOfList = []
  selectedFreeFloatAsOfDate
  listOfFreeFloat = null
  subscription: Subscription
  asOfControl = new FormControl()
  freeFloatTableOptions: DataTables.Settings = {}
  newSearchInput = ''
  freeFloatHeader = ['% Free float', 'No. of SHLD']
  freeFloateDate

  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const { freeFloat } = this.activatedRoute.snapshot.params
    this.freeFloateDate = freeFloat
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.newSearchInput = response['securitySymbol']
        this.getFreeFloatAsOfDate(this.newSearchInput)
      })

    this.freeFloatTableOptions = {
      paging: false,
      searching: false,
      info: false,
      ordering: false
    }

    this.asOfControl.valueChanges.distinctUntilChanged().subscribe(newValue => {
      if (!newValue) {
        return
      }
      if (this.freeFloateDate !== undefined) {
        this.getFreeFloatData(this.newSearchInput, this.formatDate(this.freeFloateDate))
      } else {
        this.getFreeFloatData(this.newSearchInput, this.formatDate(newValue))
      }
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  formatDate(date) {
    const d = new Date(date)
    let month = '' + (d.getMonth() + 1)
    let day = '' + d.getDate()
    const year = d.getFullYear()

    if (month.length < 2) {
      month = '0' + month
    }
    if (day.length < 2) {
      day = '0' + day
    }

    return [year, month, day].join('-')
  }

  getFreeFloatAsOfDate(symbol) {
    this.cpmService.getFreeFloatAsOfDate(symbol).then(
      response => {
        this.asOfList = response
        const lastOfList =
          response.length < 1 ? '' : this.formatDate(response[0])
        if (this.freeFloateDate !== undefined) {
          this.selectedFreeFloatAsOfDate = this.freeFloateDate
          this.getFreeFloatData(this.newSearchInput, this.formatDate(this.freeFloateDate))
        } else {
          this.selectedFreeFloatAsOfDate = response.length < 1 ? '' : response[0]
          this.getFreeFloatData(this.newSearchInput, lastOfList)
        }
      },
      err => { }
    )
  }

  getFreeFloatData(symbol, date) {
    if (!date) {
      return
    }
    this.cpmService.getFreeFloat(symbol, date).then(
      response => {
        this.listOfFreeFloat = response
      },
      err => { }
    )
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/free-float/free-float.component.ts